import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { DatePicker, Empty } from "antd";
import moment from "moment";

import TableComponent from "../../../../_metronic/table/TableComponent";

const { RangePicker } = DatePicker;

export default function ItemWiseSaleReport() {
  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().endOf("month");
  const formatStart = startOfMonth.format("YYYY-MM-DD");
  const formatEnd = endOfMonth.format("YYYY-MM-DD");

  const [headers, setHeaders] = useState([]);
  const [itemWiseReport, setItemWiseReport] = useState([]);

  const [start_date_range, setstart_date_range] = useState(formatStart);
  const [end_date_range, setend_date_range] = useState(formatEnd);
  const [isEmpty, setIsEmpty] = useState(false);

  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const getReportData = async (url, setData, setHeader) => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/${url}/B2C`,
      {
        start_date: start_date_range,
        end_date: end_date_range,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      if (data.data.length) {
        setData(data.data);
        const singleData = data.data[0];
        const makeHeader = [];
        for (let key in singleData) {
          makeHeader.push({ label: key, key: key });
        }
        setHeader(makeHeader);
        setIsEmpty(false);
      } else {
        setData([]);
        setIsEmpty(true);
        setHeader([]);
      }
    } else {
      swal({
        title: "Something went wrong",
        icon: "error",
      });
    }
  };

  
  useEffect(() => {
    getReportData("itemWiseSalesReport", setItemWiseReport, setHeaders);
  }, [end_date_range]);

  // React Table
  const data = React.useMemo(() => itemWiseReport, [itemWiseReport]);

  const columns = React.useMemo(() => [
    {
      Header: "#",
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: "name",
      accessor: "name",
      paddingLeft: "0px",
    },
    {
      Header: "Product code",
      accessor: "product_code",
      paddingLeft: "0px",
    },
    {
      Header: "product id",
      accessor: "product_id",
      paddingLeft: "0px",
    },

    {
      Header: "volume In Kg",
      accessor: "volumeInKg",
      paddingLeft: "0px",
    },
    {
      Header: "total Discount",
      accessor: "totalDiscount",
      paddingLeft: "0px",
    },
    {
      Header: "invoice Count",
      accessor: "invoiceCount",
      paddingLeft: "0px",
    },
    {
      Header: "volume Qty",
      accessor: "volumeQty",
      paddingLeft: "0px",
    },
    {
      Header: "total Value",
      accessor: "totalValue",
      paddingLeft: "0px",
    },
    {
      Header: "total Vat",
      accessor: "totalVat",
      paddingLeft: "0px",
    },
    {
      Header: "net Amount",
      accessor: "netAmount",
      paddingLeft: "0px",
    },
    {
      Header: "total Orders",
      accessor: "totalOrders",
      paddingLeft: "0px",
    },
  ]);

  const handleDateRange = (dateArr, date) => {
    const dates = [...dateArr];
    setstart_date_range(dates[0]);
    setend_date_range(dates[1]);
  };
  return (
    <div>
      <div className="card p-5 mb-5">
        <div className="col-md-12">
          <h2 className="mb-5">Item wise Sales Report</h2>
        </div>
        <div className="col-md-4">
          <div>
            <label htmlFor="">Select Date</label>
          </div>
          <RangePicker
            defaultValue={[startOfMonth, endOfMonth]}
            format={"YYYY-MM-DD"}
            onChange={(date, dateString) => handleDateRange(dateString, date)}
          />
        </div>
      </div>
      {isEmpty ? (
        <Empty />
      ) : (
        <TableComponent
          columns={columns}
          title="Itemwise Sales report"
          data={data}
          lists={itemWiseReport}
          hideAddButton={true}
          csv={true}
          excelHeader={headers}
          filename={"Itemwise Sales Report.csv"}
        />
      )}
    </div>
  );
}
